export default function (id) {
    return {
        type: 'NOTIFICATIONS_REMOVE',
        id
    };
}
